<template>
  <router-view />
</template>

<script>
export default {
  name: "App",
  metaInfo() {
    return {
      title: "Build Your Own Case Study - Medical Learning Institute,",
      titleTemplate: "%s | BYOCS",
    };
  },
};
</script>
